import * as React from "react";
import { Company } from "../../../../domain/model/company";
import { Project } from "../../../../domain/model/project";

import { TCompanyWithProjectID } from "../../../../domain/repository/company_repository";
import styled from "styled-components";
import ProjectCustomerCard from "../../../common/organism/card/project_customer_card";
import {
  ConstBreakPoint,
  ConstCalc,
} from "../../../../config/styles_const/styles_const";
import Slider, { Settings } from "react-slick";
import SlidePrevArrow from "../../../common/atom/slider_arrow/slide_prev_arrow";
import SlideNextArrow from "../../../common/atom/slider_arrow/slide_next_arrow";

const cardMargin = 15;
const cardWidth = 280 + cardMargin;
// カード + 外のマージン
const threeCard = cardWidth * 3 + 100 + 1;
const twoCard = cardWidth * 2 + 100 + 1;
// breackpoint は調整必要
const settings: Settings = {
  className: "slider",
  dots: false,
  infinite: false,
  centerMode: false,
  swipeToSlide: true,
  variableWidth: true,
  arrows: true,
  prevArrow: <SlidePrevArrow />,
  nextArrow: <SlideNextArrow />,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: threeCard,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: twoCard,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

interface IProps {
  projects: Project[];
  companiesWithProjectID: TCompanyWithProjectID[];
}

export const CustomerProjectsSlick: React.FC<IProps> = (props) => {
  const { projects, companiesWithProjectID } = props;

  // projectId: Companyの連想配列を作成し、Projectから連携させる。
  const hashCompany: { [projectId: string]: Company } = {};
  for (const item of companiesWithProjectID) {
    hashCompany[item.projectID] = item.company;
  }

  return (
    <React.Fragment>
      <SliderWrapper>
        <Slider {...settings}>
          {projects.map((project: Project, index: number) => {
            const projectId: string = project.id;
            const company: Company | undefined = hashCompany[projectId];
            if (!company) {
              return null;
            }
            return (
              <ProjectCardWrapper key={projectId} style={{ width: cardWidth }}>
                <ProjectCustomerCard
                  company={company}
                  project={project}
                  user={null}
                  contract={null}
                />
              </ProjectCardWrapper>
            );
          })}
        </Slider>
      </SliderWrapper>
    </React.Fragment>
  );
};

export default CustomerProjectsSlick;

const SliderWrapper = styled.div`
  margin-bottom: 40px;

  // react-slickの横幅の計算がうまく働いていないのでここで決めている感じ
  max-width: ${ConstCalc.CustomerSlideMaxWidthSp};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-bottom: 50px;
    max-width: ${ConstCalc.CustomerSlideMaxWidthTablet};
  }
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    max-width: ${ConstCalc.CustomerSlideMaxWidthPc};
  }

  // 一部で縦の大きさが変動していたため固定する
  & .slick-slider {
    height: 355px;
  }
`;

const ProjectCardWrapper = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: ${cardMargin}px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects_slick.tsx